import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * First access flow (configurable):
 * 1. Enter identifier (CF/Email/username depending on project) → receive OTP
 * 2. Enter OTP code
 * 3. Choose password → account activated
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthConfig } from '../config';
import { authApi, ApiClientError } from '../services/api-client';
import { Button, Input, PasswordRequirements, isPasswordValid } from './ui';
export function FirstAccessPage({ className }) {
    const navigate = useNavigate();
    const config = getAuthConfig();
    const { login: loginConfig } = config;
    const [step, setStep] = useState('identify');
    const [identifier, setIdentifier] = useState('');
    const [profileId, setProfileId] = useState('');
    const [otp, setOtp] = useState('');
    const [verificationToken, setVerificationToken] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const handleIdentify = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = await authApi.post('/auth/first-access', { identifier });
            setProfileId(response.data.profileId);
            setStep('otp');
        }
        catch (err) {
            if (err instanceof ApiClientError) {
                setError(err.message);
            }
            else {
                setError('Errore di connessione. Riprova.');
            }
        }
        finally {
            setLoading(false);
        }
    };
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const response = await authApi.post('/auth/verify-otp', { profileId, otpCode: otp });
            setVerificationToken(response.data.verificationToken);
            setStep('password');
        }
        catch (err) {
            if (err instanceof ApiClientError) {
                setError(err.message);
            }
            else {
                setError('Errore di connessione. Riprova.');
            }
        }
        finally {
            setLoading(false);
        }
    };
    const handleSetPassword = async (e) => {
        e.preventDefault();
        setError('');
        if (password !== confirmPassword) {
            setError('Le password non corrispondono');
            return;
        }
        if (!isPasswordValid(password)) {
            setError('La password non rispetta tutti i requisiti');
            return;
        }
        setLoading(true);
        try {
            await authApi.post('/auth/complete-registration', { profileId, verificationToken, newPassword: password });
            navigate('/login?registered=true', { replace: true });
        }
        catch (err) {
            if (err instanceof ApiClientError) {
                setError(err.message);
            }
            else {
                setError('Errore di connessione. Riprova.');
            }
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx("div", { className: `ipsoft-login-page ${className || ''}`, children: _jsxs("div", { className: "ipsoft-login-card", children: [_jsx("h1", { children: "Primo Accesso" }), error && (_jsx("div", { className: "ipsoft-alert ipsoft-alert-error", role: "alert", children: error })), step === 'identify' && (_jsxs("form", { onSubmit: handleIdentify, "aria-label": "Identificazione", children: [_jsxs("p", { className: "ipsoft-text-muted", style: { marginBottom: '1rem' }, children: ["Inserisci il tuo ", loginConfig.labels.identifierPlaceholder.toLowerCase(), " registrato dall'amministratore."] }), _jsx(Input, { label: loginConfig.labels.identifierPlaceholder, value: identifier, onChange: (e) => setIdentifier(e.target.value), required: true, autoComplete: "username", autoFocus: true }), _jsx(Button, { type: "submit", loading: loading, fullWidth: true, style: { marginTop: '1rem' }, children: "Invia codice OTP" }), _jsx("div", { style: { textAlign: 'center', marginTop: '1rem' }, children: _jsx("a", { href: "/login", className: "ipsoft-link", children: "Torna al login" }) })] })), step === 'otp' && (_jsxs("form", { onSubmit: handleVerifyOtp, "aria-label": "Verifica OTP", children: [_jsx("p", { className: "ipsoft-text-muted", style: { marginBottom: '1rem' }, children: "Abbiamo inviato un codice di 6 cifre alla tua email. Inseriscilo qui sotto." }), _jsx(Input, { label: "Codice OTP", value: otp, onChange: (e) => setOtp(e.target.value.replace(/\D/g, '')), required: true, inputMode: "numeric", maxLength: 6, autoComplete: "one-time-code", autoFocus: true, helpText: "Hai 15 minuti per inserire il codice. Dopo 3 tentativi errati verr\u00E0 bloccato." }), _jsx(Button, { type: "submit", loading: loading, fullWidth: true, style: { marginTop: '1rem' }, children: "Verifica codice" })] })), step === 'password' && (_jsxs("form", { onSubmit: handleSetPassword, "aria-label": "Scelta password", children: [_jsx("p", { className: "ipsoft-text-muted", style: { marginBottom: '1rem' }, children: "Scegli una password sicura per il tuo account." }), _jsx(Input, { label: "Nuova password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), required: true, autoComplete: "new-password", autoFocus: true }), _jsx(PasswordRequirements, { password: password }), _jsx(Input, { label: "Conferma password", type: "password", value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value), required: true, autoComplete: "new-password" }), _jsx(Button, { type: "submit", loading: loading, fullWidth: true, style: { marginTop: '1rem' }, children: "Completa registrazione" })] }))] }) }));
}
//# sourceMappingURL=FirstAccessPage.js.map